'use strict';
define([
    'angular',
    'modules/serpchecker/dialogs/edit-competitors/edit-competitors.controller',
    'modules/serpchecker/dialogs/metrics/metrics.controller',
], function (
    angular,
    SerpCheckerEditCompetitorsCtrl,
    SerpCheckerMetricsCtrl,
) {
    var app = angular.module('app.serpchecker.dialogs', []);
    app.controller('SerpCheckerEditCompetitorsCtrl', SerpCheckerEditCompetitorsCtrl);
    app.controller('SerpCheckerMetricsCtrl', SerpCheckerMetricsCtrl);

    return app;
});
